// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function esReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.CREATE_ES_SUCCESS:
            return [...state, Object.assign({}, action.es)];
        case types.UPDATE_ES_SUCCESS:
            return [...state.filter(es => es.esId != action.es.esId), Object.assign({}, action.es)];
        case types.GET_ES_SUCCESS:
            return [...state.filter(es => es.esId != action.es.esId), Object.assign({}, action.es)];
        case types.DELETE_ES_SUCCESS:
            return [...state.filter(es => es.esId != action.es.esId)];
        case types.LOAD_ES_SUCCESS:
            return action.es;
        
        default:
            return state;
    };
};

